import { useEffect } from 'react';

export const usePageMeta = (title, description) => {
  useEffect(() => {
    if (title) {
      document.title = title;
      const ogTitle = document.querySelector("meta[property='og:title']");
      if (ogTitle) ogTitle.setAttribute('content', title);
      const twitterTitle = document.querySelector("meta[name='twitter:title']");
      if (twitterTitle) twitterTitle.setAttribute('content', title);
    }
    if (description) {
      let metaDesc = document.querySelector("meta[name='description']");
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.setAttribute('name', 'description');
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', description);

      const ogDesc = document.querySelector("meta[property='og:description']");
      if (ogDesc) ogDesc.setAttribute('content', description);
      const twitterDesc = document.querySelector("meta[name='twitter:description']");
      if (twitterDesc) twitterDesc.setAttribute('content', description);
    }
  }, [title, description]);
};

export default usePageMeta;
